<template>
  <v-card class="white--text" color="primary darken-2" flat>
      <v-card-title class="pa-0">
          <span id="title-text">Situação por período</span>
        </v-card-title>
      <v-card-subtitle class="pa-0 mt-2">
            <v-icon class="mr-2" size="18" color="secondary lighten-1">mdi-select-group</v-icon>
            <span id="basin-text">{{basin.text}}</span>
      </v-card-subtitle>
      <v-card-text class="pa-0 white--text">
        <v-row>
          <v-col cols="12">
            <search-period-date
              :basin="basin"
              @applyPeriod="applyDateSelected($event)"
            >
            </search-period-date>
          </v-col>

          <v-col class="pt-6" cols="12">
            <h3 style="font-family: Roboto;font-style: normal;font-weight: bold;font-size: 16px;line-height: 20px;">Reservatórios</h3>
            <h4 style="font-family: Roboto;font-style: normal;font-weight: 300;font-size: 14px;line-height: 20px;">Dados agrupados dos reservatórios: Iraí, Passaúna, Piraquara I e Piraquara II.</h4>
          </v-col>

          <v-col cols="12">
            <div v-if="showAnimation" style="height: 300px;">
              <loading-animation
                @loopComplete="loadAnimationComplete"
              >
              </loading-animation>
            </div>
            <volume-charts
              v-show="!showAnimation"
              :periodDate="periodDate"
              :basin="basin"
              tabName="saic"
              :usefulVolume="usefulVolumeData"
              :usefulVolumePercentage="usefulVolumeDataPercentage"
            >
            </volume-charts>
          </v-col>
          <v-col cols="12">
            <div v-if="showAnimation" style="height: 300px;">
              <loading-animation
                @loopComplete="loadAnimationComplete"
              >
              </loading-animation>
            </div>
            <useful-volume-area
              v-show="!showAnimation"
              :periodDate="periodDate"
              :basin="basin"
              :usefulVolume="usefulVolumeData"
              tabName="saic"
            >
            </useful-volume-area>
          </v-col>
        </v-row>
      </v-card-text>
  </v-card>
</template>

<script>
import SearchPeriodDate from '../common/SearchPeriodDate.vue';
import VolumeCharts from '../common/VolumeCharts.vue';
import UsefulVolumeArea from '../common/UsefulVolumeArea.vue';
import LoadingAnimation from '../../common/LoadingAnimation.vue';
export default {
  components: { SearchPeriodDate, VolumeCharts, UsefulVolumeArea, LoadingAnimation},
    name: 'SaicSearchPeriodDate',
    props:['basin'],
    data:()=>({
      periodDate: undefined,
      showAnimation: false,
      loading: false,
      usefulVolumeData: [],
      usefulVolumeDataPercentage: [],
    }),
    watch:{
      periodDate(value){
        if(value){
          this.initializeData();
        }
      },
      basin(value){
        if(value){
          this.initializeData();
        }
      },
    },
    computed:{
      suppliedInhabitants(){
        return this.$store.getters.suppliedInhabitants;
      },
      unSuppliedInhabitants(){
        return this.$store.getters.unSuppliedInhabitants;
      },
      currentDemand(){
        return this.$store.getters.currentDemand;
      },
      savedDemand(){
        return this.$store.getters.savedDemand;
      },
    },
    methods:{
      async initializeData(){
        if(this.periodDate){
          this.loading = true;
          this.showAnimation = true;
          const date_start = this.periodDate.period[0];
          const date_end = this.periodDate.period[1];
          const { type } = this.periodDate;
          let temp_data;
          if(type === "Mensal") {
            await this.$store.dispatch('loadSaicMonthlySummary', {startDate: date_start, endDate: date_end});
            const aux_temp_data = await this.$store.getters.saicMonthlySummary;
            temp_data = aux_temp_data.map((item)=> {
              return {...item, date: item.dateYM}
            })
          } else {
            await this.$store.dispatch('loadSaicDailySummary', {startDate: date_start, endDate: date_end});
            temp_data = await this.$store.getters.saicDailySummary;
          }
          temp_data = temp_data.reverse();
          this.usefulVolumeData = this.groupSaicVolume(temp_data, "waterVolume");
          this.usefulVolumeDataPercentage  = this.groupSaicVolume(temp_data, "waterVolumePerc");

          this.loading = false;
        }
      },

      applyDateSelected(period){
        this.periodDate = period;
      },

      loadAnimationComplete(){
        this.showAnimation = this.loading;
      },

      groupSaicVolume(volumeData, type){
        if(volumeData){
          let dateGroups = [];
          let volumeSaicGroup = [];
          for (const volume of volumeData) {
            const { date } = volume;
            if(dateGroups.indexOf(date) === -1) dateGroups.push(date);
          }
          for (const dateGroup of dateGroups) {
            const volumesOfGroup = volumeData.filter((volume) => volume.date === dateGroup);
            const sum = volumesOfGroup.reduce((before, current) => {
              if(type == 'waterVolume'){
                return before + current.waterVolume;
              } else {
                return before + current.waterVolumePerc;
              }
            }, 0);
            volumeSaicGroup.push({data: dateGroup, valor: sum});
          }
          return volumeSaicGroup;
        }

        return [];
      },
    },

}
</script>

<style scoped>
    #title-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 23px;
        color: #fff;
    }

    #basin-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
    }
</style>
